// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { ElevatorGroupSupervisoryStatusMessage, ElevatorGroupSupervisoryStatusMessageT } from './elevator-group-supervisory-status-message';
import { EscalatorGroupSupervisoryStatusMessage, EscalatorGroupSupervisoryStatusMessageT } from './escalator-group-supervisory-status-message';


export enum DeviceGroupSupervisoryStatusContent {
  NONE = 0,
  ElevatorGroupSupervisoryStatusMessage = 1,
  EscalatorGroupSupervisoryStatusMessage = 2
}

export function unionToDeviceGroupSupervisoryStatusContent(
  type: DeviceGroupSupervisoryStatusContent,
  accessor: (obj:ElevatorGroupSupervisoryStatusMessage|EscalatorGroupSupervisoryStatusMessage) => ElevatorGroupSupervisoryStatusMessage|EscalatorGroupSupervisoryStatusMessage|null
): ElevatorGroupSupervisoryStatusMessage|EscalatorGroupSupervisoryStatusMessage|null {
  switch(DeviceGroupSupervisoryStatusContent[type]) {
    case 'NONE': return null; 
    case 'ElevatorGroupSupervisoryStatusMessage': return accessor(new ElevatorGroupSupervisoryStatusMessage())! as ElevatorGroupSupervisoryStatusMessage;
    case 'EscalatorGroupSupervisoryStatusMessage': return accessor(new EscalatorGroupSupervisoryStatusMessage())! as EscalatorGroupSupervisoryStatusMessage;
    default: return null;
  }
}

export function unionListToDeviceGroupSupervisoryStatusContent(
  type: DeviceGroupSupervisoryStatusContent, 
  accessor: (index: number, obj:ElevatorGroupSupervisoryStatusMessage|EscalatorGroupSupervisoryStatusMessage) => ElevatorGroupSupervisoryStatusMessage|EscalatorGroupSupervisoryStatusMessage|null, 
  index: number
): ElevatorGroupSupervisoryStatusMessage|EscalatorGroupSupervisoryStatusMessage|null {
  switch(DeviceGroupSupervisoryStatusContent[type]) {
    case 'NONE': return null; 
    case 'ElevatorGroupSupervisoryStatusMessage': return accessor(index, new ElevatorGroupSupervisoryStatusMessage())! as ElevatorGroupSupervisoryStatusMessage;
    case 'EscalatorGroupSupervisoryStatusMessage': return accessor(index, new EscalatorGroupSupervisoryStatusMessage())! as EscalatorGroupSupervisoryStatusMessage;
    default: return null;
  }
}
